import { AppState } from '../../app/state/AppState';
import { DisplaySettings } from '../state/DisplaySettingsState';

export function selectDisplaySettings(state: AppState): DisplaySettings {
  return state.displaySettings;
}
